import { z } from 'zod';

/**
 * Shape for the flat slug-list registries (career clusters, consideration
 * areas): an array of non-empty slug strings. Unlike the skills registry (an
 * object keyed by slug), these are plain arrays — membership is all the
 * validator needs. (The content-assets registry is NOT flat — it is keyed by
 * template name; see `contentAssets.ts`.)
 */
export const SlugListRegistry = z.array(z.string().min(1));

export type SlugListRegistry = z.infer<typeof SlugListRegistry>;
